export default {"src":"/_next/static/media/pdf.f8afd70c.svg","height":512,"width":513};